var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.44 33.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-B8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1298147480736",
    "data-name": 1298147480736
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85,3.33,8.46,2.6c-.64-1.2.36-.49-.73-.94-.61.74,0,1.83,0,3.05a20.35,20.35,0,0,1-3.87-.27c.24.9,0,.67,1,1a6.5,6.5,0,0,0,2.08.13v.28c-12.2,0-5.24,18.11-1.66,20.51,0-3.17-1.09-6.18.74-10.34.77-1.73,1.48-2,2.31-3.24,4.62,3.09,2.48,3,8.59,4.43-1-1.35-2.59-.76-3-2.49,12.52,0,12.42-4.67,15-.27a26.53,26.53,0,0,1,2.77,10.52c1.22-.32,1.72-1.72,2.05-2.94a16.71,16.71,0,0,0,.44-4.54,4.17,4.17,0,0,0,1.39.55c0-3.08-2.62-8.58-5-11.06C23.57-.12,16.75,2.4,15.21,1.66a3.52,3.52,0,0,1,.64-.74c.76-.78.38.09.75-.92-2.58,0-3-.08-4.73.82-1.51.78-1.78,1.66-3,2.5Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.27,29.38c-5.31-3.56-6.4,3.56-9.5.9L8,29.38c-1,4.11,1.49,3.87,6.65,3.87,3.41,0,1.24-1.18,5.37-.39,1.55.3,8.77.92,8.77-2.1a3.9,3.9,0,0,0-.28-1.39c-1.59.64.7,1.11-2.49,1.11-2.13,0-5.07-4.78-7.76-1.11Z",
    transform: "translate(0 0)",
    fill: "#131e2f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB8);
export default __webpack_public_path__ + "static/media/B8.22dbc17bd4ccc730184dd7b4860ac415.svg";
export { ForwardRef as ReactComponent };